import { Component, HostBinding } from "@angular/core";

@Component({
  selector: "ngx-vertical-tabs",
  templateUrl: "./vertical-tabs.component.html",
  standalone: false,
})
export class VerticalTabsComponent {
  @HostBinding("class.w-full") fullWidth = true;
}
